module.exports = "<p>adminpartner works!</p>\n"